<template>
<div>
	<div class="row" style="min-height: 3em">
		<div class="col-12 col-md-12">

			<div v-show="privilegio_ != 0 ? _getPrivilegio(privilegio_) : false"
				class="float-left"
				style="margin-right:1em">
				<toggle-button
					@change="(val) => $emit('ativaDesativaProcessamento', val, nome)"
					:width="100"
					:height="20"
					:sync="true"
					:value="habilitado_"
					:labels="{checked: 'ATIVADO', unchecked: 'DESATIVADO'}"
					:color="{checked: '#28a745', unchecked: '#dc3545'}"/>
			</div>

			<br v-if="_isMobile" />
			<br v-if="_isMobile" />

			<h5 :class="{'text-secondary' : !processando_, 'text-success': processando_}" style="margin-bottom:0px">
				<fa-icon icon="satellite" />
				{{descricao_}}
				<br />
				<small v-if="processando_">
					<fa-icon v-if="processando_" icon="sync-alt" spin/>
					<span v-if="status_">{{status_}}...</span>
				</small>
			</h5>
		</div>
	</div>

</div>
</template>

<script>
export default {

	props: {

		nome:{
			type: String,
			requeired: true,
			default: "",
		},

		descricao:{
			type: String,
			requeired: true,
			default: "",
		},

		processando:{
			type: Boolean,
			requeired: true,
			default: true,
		},

		status:{
			type: String,
			requeired: true,
			default: null,
		},

		habilitado:{
			type: Boolean,
			requeired: true,
			default: false,
		},

		privilegio:{
			type: Number,
			requeired: true,
			default: 0,
		},
	},

	data (){
		return {
			nome_ : this.nome,
			descricao_ : this.descricao,
			processando_ : this.processando,
			status_ : this.status,
			habilitado_ : this.habilitado,
			privilegio_ : this.privilegio,
		}
	},

	watch: {

		privilegio (val, oldVal) {
			this.privilegio_ = val
		},

		habilitado (val, oldVal) {
			this.habilitado_ = val
		},

		descricao (val, oldVal) {
			this.descricao_ = val
		},

		nome (val, oldVal) {
			this.nome_ = val
		},

		status (val, oldVal) {
			this.status_ = val
		},

		processando (val, oldVal){
			this.processando_ = val
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/views/processamento/item-processamento.vue